import React from 'react';
import { connect } from 'react-redux';
import styles from './index.pcss';
import classNames from 'classnames/bind';
import { downloadInvoiceCall } from '../../../../actions/orders';

const cx = classNames.bind(styles);
interface GSTInvoiceProps {
  onClose: () => void;
  orderLevelDetail?: any;
  downloadInvoiceCall?: (params: any) => Promise<any>;
  luxe?: boolean;
}
interface GSTInvoiceState {
  downloadingShipments: { [key: number]: boolean };
}

class GSTInvoice extends React.Component<GSTInvoiceProps, GSTInvoiceState> {
  constructor(props: GSTInvoiceProps) {
    super(props);
    this.state = {
      downloadingShipments: {}
    };
  }

  isInvoiceAvailable = (status: string): boolean => {
    const downloadableStatuses = [
      'DELIVERED',
      'RETURN_INITIATED',
      'REFUND_INITIATED',
      'PARTIALLY_REFUND_INITIATED',
      'PARTIALLY_RETURNED',
      'PARTIALLY_RETURN_INITIATED',
      'PARTIALLY_REFUND'
    ];
    return downloadableStatuses.includes(status?.toUpperCase());
  };

  getShipmentsWithInvoices = () => {
    const { orderLevelDetail = {} } = this.props;
    const { consignmentsData = [] } = orderLevelDetail;
    const temp = consignmentsData?.filter((consignment: any) => {
      const currentStatus = consignment?.status || consignment?.shipmentStatus;
      return this.isInvoiceAvailable(currentStatus);
    });
    return temp;
  };

  getProductsWithNoInvoice = () => {
    const { orderLevelDetail = {} } = this.props;
    const {
      consignmentsData = [],
      confirmedEntries = [],
      cancelledEntries = []
    } = orderLevelDetail;
    const temp1: string[] = consignmentsData?.flatMap((consignment: any) =>
      consignment?.returnRequests?.flatMap((req: any) =>
        req?.returnEntries
          ?.map((retEntry: any) => {
            const thumb = retEntry?.entry?.product?.images?.find(
              (img: any) => img?.format === 'thumbnail'
            );
            return thumb?.url ?? '';
          })
          .filter(Boolean)
      )
    );
    const temp2 = confirmedEntries.map((entry: any) => {
      return entry?.entry?.product.images.find((img: any) => img.format === 'thumbnail').url;
    });
    const temp3 = cancelledEntries.map((entry: any) => {
      return entry?.entry?.product.images.find((img: any) => img.format === 'thumbnail').url;
    });
    return [...temp1, ...temp2, ...temp3];
  };

  getProductsLabelsWithNoInvoice = () => {
  const { orderLevelDetail = {} } = this.props;
  const {
    consignmentsData = [],
    confirmedEntries = [],
    cancelledEntries = []
  } = orderLevelDetail;
  const temp1: string[] = consignmentsData?.flatMap((consignment: any) =>
    consignment?.returnRequests?.flatMap((req: any) =>
      req?.returnEntries
        ?.map((retEntry: any) => {
          let label = 'product';
          if(retEntry?.entry?.product?.brandName && retEntry?.entry?.product?.name){
            label = retEntry?.entry?.product?.brandName + ' ' + retEntry?.entry?.product?.name
          }
          return label
        })
        .filter(Boolean)
    )
  );

    const temp2 = confirmedEntries.map((entry: any) => {
      let label = 'product';
      if (entry?.entry?.product?.brandName && entry?.entry?.product?.name) {
        label = entry?.entry?.product?.brandName + ' ' + entry?.entry?.product?.name
      }
      return label
    })

    const temp3 = cancelledEntries.map((entry: any) => {
      let label = 'product';
      if (entry?.entry?.product?.brandName && entry?.entry?.product?.name) {
        label = entry?.entry?.product?.brandName + ' ' + entry?.entry?.product?.name
      }
      return label
    })

    return [...temp1, ...temp2, ...temp3];
};


  handleDownloadInvoice = async (orderId = '', consignmentCode = '') => {
    const params = { orderId, consignmentCode };
    const timeStamp = new Date().getTime();
    let fileName = `Ajio_${orderId}_${timeStamp}.pdf`;
    this.props.downloadInvoiceCall(params).then(({ data }) => {
      if (data) {
        var link = document.getElementById('dwnldInvHideLink');
        link.href = data;
        link.download = fileName;
        link.click();
      }
    });
  };

  renderProductImages = (entries: any[] = []) => {
    const maxImages = 10;
    const imagesToShow = entries.slice(0, maxImages);
    return imagesToShow.map((entry: any, index: number) => {
      const { orderEntry = {} } = entry;
      const { product = {} } = orderEntry;
      const { images = [] } = product;
      const productImage = images.find((img: any) => img.format === 'thumbnail');

      let label = `${product.brandName || ''} ${product.name || ''} `

      if(!label.trim()){
        label = productImage.altText || 'product'
      }
      
      if (productImage) {
        return <img key={index} src={productImage.url} alt={label} />;
      }
      return <div key={index} />;
    });
  };

  renderShipmentSection = (consignment: any, index: number) => {
    const { orderLevelDetail = {} } = this.props;
    const { code: orderId = '' } = orderLevelDetail;
    const { downloadingShipments } = this.state;
    const { code: consignmentCode = '', shipmentStatus = '', entries = [] } = consignment;
    const currentStatus = shipmentStatus;
    const isDownloading = downloadingShipments[index];
    const displayStatus =
      currentStatus.charAt(0).toUpperCase() + currentStatus.slice(1).toLowerCase();
    return (
      <div key={`${consignmentCode}-${index}`} className={cx('shipment-section')}>
        {/* TODO-GST - remove inline css */}
        <div className={cx('header')} style={{ display: 'flex' }}>
          <div className={cx('title')} style={{ display: 'flex' }}>
            <div className={cx('shipment-number')}>Shipment {index + 1}</div>
            <div className={cx('shipment-status')}>{displayStatus}</div>
          </div>
          <a id="dwnldInvHideLink" style={{ display: 'none' }} />
          <div
            className={cx(isDownloading ? 'download-btn-disabled' : 'download-btn')}
            onClick={() => !isDownloading && this.handleDownloadInvoice(orderId, consignmentCode)}
            role='button'
            tabIndex={0}
            aria-disabled={isDownloading}
          >
            {isDownloading ? 'Downloading...' : 'Download Invoice'}
          </div>
        </div>
        <div className={cx('product-grid')}>{this.renderProductImages(entries)}</div>
      </div>
    );
  };

  renderOtherProducts = () => {
    let productsImagesWithNoInvoice = this.getProductsWithNoInvoice();
    productsImagesWithNoInvoice = productsImagesWithNoInvoice.filter(Boolean);
    if (productsImagesWithNoInvoice.length === 0) return;

    let productsLabelsWithNoInvoices = this.getProductsLabelsWithNoInvoice()
    return (
      <div className={cx('shipment-section')}>
        {/* TODO-GST - remove inline css */}
        <div className={cx('header')} style={{ display: 'flex' }}>
          <div className={cx('title')} style={{ display: 'flex' }}>
            <div className={cx('shipment-number')}>Other products in the order</div>
          </div>
          <div className={cx('download-btn', 'download-btn-disabled')} role='button' tabIndex={0} aria-disabled="true">Download Invoice</div>
        </div>
        <div className={cx('product-grid')}>
          {productsImagesWithNoInvoice.map((imgUrl: string, index: number) => (
            <img key={index} src={imgUrl} alt={productsLabelsWithNoInvoices[index] || 'product'} className={cx('disabled-img')}/>
          ))}
        </div>
      </div>
    );
  };

  render() {
    const { onClose, luxe } = this.props;
    const shipmentsWithInvoices = this.getShipmentsWithInvoices();
    return (
      <div className={luxe ? cx('luxe-invoice-dialog-content') : cx('invoice-dialog-content')}>
        <div className={cx('invoice-modal-title')} role='heading' aria-level={2}>Download Invoice</div>
        <div className={cx('invoice-modal-subheading')}>
          Invoice will be available once the products are delivered
        </div>
        {shipmentsWithInvoices?.length > 0 ? (
          <>
            {shipmentsWithInvoices.map((consignment: any, index: number) =>
              this.renderShipmentSection(consignment, index)
            )}
            {this.renderOtherProducts()}
          </>
        ) : (
          <div></div>
        )}
        <button
          type="button"
          className={cx(
            'rilrtl-button',
            'rilrtl-button--primary',
            'rilrtl-button-bg--primary',
            'okay-button'
          )}
          onClick={onClose}
        >
          Okay
        </button>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    downloadInvoiceCall: (params: any) => dispatch(downloadInvoiceCall(params))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GSTInvoice);
